export var Template = (window.Template = (function() {
   var cachedTemplates = {};

   function getCompiledTemplate(str) {
      var template = Handlebars.compile(str);
      return function(data, asString) {
         var html = template(data);
         if (asString) {
            return html;
         } else {
            return htmlToDom(html);
         }
      };
   }

   /**
    * Converts a string of HTML to a DOM element.
    *
    * Returns:
    *   - One element if passed something like "<div>...</div>"
    *   - Array of elements if passed "<a>...</a><a>...</a>"
    */
   function htmlToDom(html) {
      var children;
      if ($.parseHTML) {
         children = $.parseHTML(html);
      } else {
         children = new Element('div', { html: html }).getChildren();
      }

      // If there is only one child, return that element instead of the
      // array.
      if (children.length === 1) {
         return children[0];
      } else {
         return children;
      }
   }

   // Public interface
   return {
      /**
       * Returns a function(data, asString) that takes in an object and
       * produces some DOM elements (or a string if asString is set).
       */
      get: function(str) {
         if (!cachedTemplates[str]) {
            cachedTemplates[str] = getCompiledTemplate(str);
         }

         return cachedTemplates[str];
      },
   };
})());
